import person from './person'

export default {
  person,
}
